import { ReactElement, useState } from 'react';
import { getProductFallbackThumbnailUrl } from '@client/routes/utils/url';
import classNames from 'classnames';
import { Props } from './';
import './Thumbnail.scss';

export const Thumbnail = ({
  url,
  isActive,
  title,
  onClick,
  productUrl,
  className,
}: Props): ReactElement => {
  const rootClassName = classNames(
    'CartProduct-Thumbnail',
    {
      'CartProduct-Thumbnail--Active': isActive,
      'cds-ImgFluid': !isActive,
      'CartProduct-Thumbnail--Fallback':
        !isActive && url.includes(getProductFallbackThumbnailUrl()),
    },
    className,
  );
  const [imgSrc, setImgSrc] = useState(url);
  const fallbackImgUrl = getProductFallbackThumbnailUrl();
  const onError = () => setImgSrc(fallbackImgUrl);

  if (isActive && onClick) {
    return (
      <a
        href={productUrl}
        onClick={onClick}
        className={rootClassName}
      >
        <img
          src={imgSrc}
          title={title || undefined}
          alt={title}
          className="cds-ImgFluid"
          onError={onError}
        />
      </a>
    );
  }

  return (
    <div className={rootClassName}>
      <img
        src={imgSrc}
        title={title || undefined}
        alt={title}
        className="cds-ImgFluid"
        onError={onError}
      />
    </div>
  );
};
